export default __webpack_public_path__ + "static/media/5.37c2d347.jpg";